<!-- O título deve ser sempre exibido, quando existir. -->
<div *ngIf="getTitle()" [innerHtml]="getTitle()" [style.font-size]="configuration.messageTextSize"></div>

<!-- Definir qual tipo de exibição é desejada -->
<div [ngSwitch]="getDisplay()">

    <!-- Exibir em formato de links listados dentro de uma <mat-selection-list> -->
    <div *ngSwitchCase="displaySelectionList">
        <mat-selection-list [disabled]="disableOptionsInput" #list [multiple]="false">
            <mat-list-option *ngFor="let option of getOptions()" [value]="option.value"
                class="message-list-options-content-item" (click)="onSelecionListClicked(option)">
                <mat-icon mat-list-icon>fiber_manual_record</mat-icon>
                <div [style.font-size]="configuration.messageTextSize">{{option.label}}</div>
            </mat-list-option>
        </mat-selection-list>
    </div>

    <!-- Exibir apenas uma lista contendo as opções, sem colocar links. -->
    <div *ngSwitchCase="displaySimpleList">
        <mat-list>
            <mat-list-item *ngFor="let option of getOptions()" class="message-list-options-content-item">
                <div [style.font-size]="configuration.messageTextSize">{{option.label}}</div>
            </mat-list-item>
        </mat-list>
    </div>

    <!-- Exibir as opções como uma lista de botões -->
    <div *ngSwitchCase="displayButton" fxLayout="row wrap">
        <div fxFill style="margin-bottom: 8px" *ngFor="let option of getOptions()">
            <button mat-raised-button style="line-height: 16px !important;
            padding: 16px; margin:8px 0px; width: 100%; height: 100%; white-space: pre-wrap !important;"
                [disabled]="disableOptionsInput" (click)="onOptionSelected(option)">{{ option.label }}</button>
        </div>
    </div>

    <!-- Exibir as opções como um select/dropdown -->
    <div *ngSwitchCase="displayDropdown">
        <mat-form-field fxFill appearance="fill">
            <mat-label>Selecione uma opção</mat-label>
            <mat-select [disabled]="disableOptionsInput" #s>
                <mat-option *ngFor="let option of getOptions()" [value]="option.value"
                    (onSelectionChange)="onMatSelectOptionSelected(option)">{{ option.label }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>